import React from 'react'

function FinanceSinglePage() {
  return (
    <div>FinanceSinglePage</div>
  )
}

export default FinanceSinglePage